goog.provide('el8.util.string');

el8.util.string = (function() {

    var that = {};

    var STD_FLOAT_PRECISION = 2;

    that = {

        removeHtmlFromStr: function(html) {
            var div = $('<div>');
            div[0].innerHTML = html;
            return div[0].textContent || div[0].innerText || '';
        },

        escapedStrEqual: function(a, b) {
            return (a.toLowerCase() === b.toLowerCase());
        },

        replaceNewlines: function(str, replaceStr) {
            return str.replace(/\n/g, replaceStr || ' ');
        },

        trimDr: function(name) {
            // If name starts with "Dr" or "Dr.", remove it
            if (!name) { return name; }
            return (name.toLowerCase().startswith('dr')) ? name.split(' ').slice(1).join(' ') : name;
        },

        cleanPhoneNum: function(str) {
            /* Prep a phone number string to be sent to server */
            if (!str) { return ''; }
            return str.replace(/[^\d]/g, '');
        },

        cleanDecimal: function(str) {
            /* Prep a decimal string to be sent to server (get rid of dollar signs, commas, etc.) */
            if (!str) { return ''; }
            str = str.replace(/[^\d\.]/g, '');
            if (!that.isNumber(str)) { return ''; }
            return str;
        },

        formatInt: function(num) {
            /**
             * Take a number and format with commas in the thousands positions, i.e.
             * 1000 --> 1,000
             * 10000 --> 10,000
             * 100000 --> 100,000
             */
            if (!that.isNumber(num)) { return ''; }
            var str = String(num);

            if (str.indexOf(".") >= 0) {
                /* If contains a ".", call formatInt recursively on first seg
                 * and keep the rest the same
                 */
                var segs = str.split(".");
                return el8.util.string.formatInt(segs[0]) + "." + segs.slice(1).join(".");
            } else {
                if (str.length > 3) {
                    var pos = str.length-3;
                    do {
                        str = str.slice(0, pos) + "," + str.slice(pos);
                        pos -= 3;
                    } while(pos > 0);
                }
                return str;
            }
        },

        formatMoney: function(num) {
            /**
             * Takes a number like 1000 and returns "$1,000.00"
             */
            if (!that.isNumber(num)) { return ''; }
            num = parseFloat(num);
            num = num.toFixed(2);
            var decimalStr = that.formatInt(num);
            if (decimalStr !== '') { return '$'+decimalStr; }
            return '';
        },

        formatPhoneNum: function(s) {
            /* Format given string as 415-555-5555 or 1-415-555-5555 or 555-5555 */
            var str = that.cleanPhoneNum(s);
            if (str.length < 7) { return ''; }
            var lastFour = str.substring(str.length - 4);
            var middleThree = str.substring(str.length - 7, str.length - 4);
            var firstThree = (str.length < 11 && str.length > 7) ? str.substring(0, str.length - 7) :
                str.substring(str.length - 10, str.length - 7);
            var prefix = (str.length > 10) ? str.substring(0, str.length - 10) : '';
            return (prefix ? (prefix + '-') : '') + (firstThree ? (firstThree + '-') : '') + middleThree + '-' + lastFour;
        },

        cleanMultiByteChars: function(str) {
            /* Our version of MySQL doesn't like 4-byte characters (usually smilies/emoji), so we strip
             * them out of text that might have been copy/pasted or written on a mobile device
             * with these characters. Regex from:
             * http://stackoverflow.com/questions/4877326/how-can-i-tell-if-a-string-contains-multibyte-characters-in-javascript */
            if (!str) { return str; }
            return str.replace(/[\uD800-\uDFFF]/g, '');
        },

        strNameEqual: function( a, b, phys ) {
            phys = (phys === true);
            if (phys) {a = that.trimDr(a);b = that.trimDr(b);}
            return (!a || !b) ? false : 
                (a.trim().toLowerCase() === b.trim().toLowerCase());
        },

        cmp: function(a, b) {
            if (a > b) { return 1; }
            if (a < b) { return -1; }
            return 0;
        },

        // Converts to first name and last name; because of Chinese names, ignore trying to identify middle name 
        convertNameStr: function( nameStr ) {
            if( !nameStr ) {
                return null;
            } else {
                var firstName = '';
                var lastName = '';
                // Check if any commas - if so, interpret first word as last name
                if( nameStr.trim().split(',').length > 1 ) {
                    var nameArray = nameStr.trim().split(',');
                    lastName = nameArray.shift().trim();
                    // TODO Doesn't trim whitespace from within firstName
                    firstName = nameArray.join(' ').trim();
                } else {
                    var nameArray = nameStr.trim().split(' ');
                    // If more than two elements, take last element as last name, and concatenate rest of elements as first name
                    if( nameArray.length > 1 ) {
                        lastName = nameArray.pop().trim();
                    }
                    // If only one element, set as first name
                    firstName = nameArray.join(' ').trim();
                }
                return { 'firstName': firstName.capitalize(), 'lastName': lastName.capitalize() };
            }
        },
        
        /* Checks to make sure a physician's name will fit in the DB without causing an error.
         * We don't use convertNameStr above because the server applies different logic for splitting first/last:
         * for the name 'A B C', convertNameStr - first(A B), last(C) ; server - first(A), last(B C)
         */
        validatePhysicianNameLength: function ( nameStr ) {
            //TODO: this should be a short-term solution, because it duplicates code that exists on the server
            var LASTNAME_MAX_LEN = 60;
            var FIRSTNAME_MAX_LEN = 50;
                
            nameStr = nameStr.trim().toLowerCase();
            var nameArray = nameStr.split(' ');
            var nameArrayLen = nameArray.length;
            
            if (nameArrayLen === 0) {
                return { result : true };
            } else if (nameArrayLen === 1) {
                if (nameArray[0].length > LASTNAME_MAX_LEN) {
                    //if only one element, treat as last name
                    return { result : false, msg : 'Physician last name in "Copy To" cannot be over ' + LASTNAME_MAX_LEN + ' characters' };
                }
            } else {
                // >= two elements
                var firstName;
                if (nameArray[0] === 'dr' || nameArray[0] === 'dr.') {
                    firstName = nameArray[1]; //don't count "Dr." as part of the name
                } else {
                    firstName = nameArray[0];
                }
                if (firstName.length > FIRSTNAME_MAX_LEN) {
                    return { result : false, msg : 'Physician first name in "Copy To" cannot be over ' + FIRSTNAME_MAX_LEN + ' characters' };
                }
                if (nameStr.length - firstName.length - 1 > LASTNAME_MAX_LEN) {
                    //count everything except first element as last name
                    return { result : false, msg : 'Physician last name in "Copy To" cannot be over ' + LASTNAME_MAX_LEN + ' characters' };
                }
            }
            
            return { result : true };
        },

        renderTime: function( timeStr ) {
            // Expect timeStr in format 00:00:00
            var strs = timeStr.split(':');
            var result = [];
            // Look at max 3 rightmost elements (HH:MM:SS)
            var units = ['h', 'm', 's'];
            for( var i=Math.min(3,strs.length); i>0; i-- ) {
                var num = parseInt(strs[i-1], 10); 
                if( num > 0 ) {
                    result.unshift( num + units.pop() );
                } else {
                    units.pop();
                }
            }
            return result.join(' ');
        },
        
        newlinesToBr : function (str) {
            if (!str) { return ''; }
            return str.replace(/\n/g, '<br>'); // intentionally don't convert space to &nbsp; because messes with html
        },
        
        brToNewlines : function (str) {
            if (!str) { return ''; }
            return str.replace(/<br>/g, '\n').replace(/\&nbsp\;/g, ' ');
        },

        _processFracResults : function(input, highPrecision) {
            var fracResults = input.match(/^([0-9]*) *([0-9]+)\/([0-9]+)$/i);

            var base = fracResults && fracResults[1] ? fracResults[1]*1 : 0;
            var fraction = fracResults && fracResults[2] && fracResults[3] ? (fracResults[2]*1)/(fracResults[3]*1) : 0;
            if (!highPrecision) { fraction = parseFloat(fraction.toFixed(STD_FLOAT_PRECISION)); } // 2 decimal places
            return base + fraction;
        },

         reducePrecision: function (factor) {
            if (!factor) { return null; }
            var f = parseFloat(factor);
            if (f === 0) {
                return f;
            } else if (f < 0.1) {
                return f.toFixed(STD_FLOAT_PRECISION);
            } else {
                return f.toFixed(1);
            }
        },

        cleanLength : function(str, highPrecision) {
            // 5'6", 65 inches, 65", 7', 65.7", etc.

            highPrecision = (highPrecision === true); // preserve max decimals after conversion; default false
            
            var inches = 0;
            str = str ? str.trim() : '';

            // First clean string to convert two single quotes '' to a double quote "
            str = str.replace("\'\'", '\"');
           
            var ftResults = str.match(/^(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(feet|foot|ft|\')/i);
            if (ftResults) {
                var feet = 0;
                if (ftResults[2]) { // have a decimal match of form 70.7
                    feet += ftResults[2];
                } else if (ftResults[3]) {
                    feet += that._processFracResults(ftResults[3], highPrecision);
                }
                inches += feet*12;
                str = str.replace(ftResults[0], "");
            }

            str = str ? str.trim() : '';
            var inResults = str.match(/^(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(inches|inch|in|ins|\"|\'|)$/i);
            if (inResults) {
                if (inResults[2]) { // have a decimal match of form 70.7
                    inches += inResults[2]*1;
                } else if (inResults[3]) {
                    inches += that._processFracResults(inResults[3], highPrecision);
                }
            }

            if (inches === 0) {
                var cms = 0;
                var cmResults = str.match(/^(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(cm|cms|centimeters)$/i);
                if (cmResults) {
                    if (cmResults[2]) { // have a decimal match of form 100.7
                        cms += cmResults[2]*1;
                    } else if (cmResults[3]) {
                        cms += that._processFracResults(cmResults[3], highPrecision);
                    }
                }
                
                inches = cms * 0.393701;
                if (!highPrecision) { inches = parseFloat(inches.toFixed(STD_FLOAT_PRECISION)); } // 2 decimal places
            }

            return inches || null;
        },

        cleanCircumference : function(str, highPrecision) {
            // like cleanLength but designed to normalize inches to CMs (and ignores feet)

            highPrecision = (highPrecision === true); // preserve max decimals after conversion; default false
            
            var cms = 0;
            str = str ? str.trim() : '';

            // First clean string to convert two single quotes '' to a double quote "
            str = str.replace("\'\'", '\"');

            var cmResults = str.match(/^(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(cm|cms|centimeters|)$/i);
            if (cmResults) {
                if (cmResults[2]) { // have a decimal match of form 100.7
                    cms += cmResults[2]*1;
                } else if (cmResults[3]) {
                    cms += that._processFracResults(cmResults[3], highPrecision);
                }
            }

            if (cms === 0) {
                var inches = 0;
                var inResults = str.match(/^(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(inches|inch|in|ins|\"|\')$/i);
                if (inResults) {
                    if (inResults[2]) { // have a decimal match of form 70.7
                        inches += inResults[2]*1;
                    } else if (inResults[3]) {
                        inches += that._processFracResults(inResults[3], highPrecision);
                    }
                }

                cms = inches * 2.54;
                if (!highPrecision) { cms = parseFloat(cms.toFixed(STD_FLOAT_PRECISION)); } // 2 decimal places
            }

            return cms || null;
        },
        
        cleanWeight: function(str, highPrecision) {
            // Accepts lbs, oz, kg, or lbs + oz
            // returns cleaned lbs, display string, and kg display
            
            highPrecision = (highPrecision === true); // preserve max decimals after conversion; default false

            // This is the value we'll eventually store in the db.
            var fractional_pounds = null;
            
            var pounds = null;
            str = str ? str.trim() : '';
            
            //var lbResults = str.match(/(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(lbs|lb|pounds|pound|)?/i);
            var lbResults = str.match(/(([0-9]* *[0-9]+\/[0-9]+)|([0-9]*\.?[0-9]+))[ ]*([a-z]*)?/i);
            if (lbResults) {

                // We should either not have units, or they should be pounds
                if (!lbResults[4] || ['lb', 'lbs', 'pound', 'pounds'].indexOf(lbResults[4]) >= 0) {
                    pounds = 0;

                    if (lbResults[3]) { // have a decimal match of form 100.7
                        pounds += lbResults[3]*1;
                    } else if (lbResults[2]) {
                        pounds += that._processFracResults(lbResults[2], highPrecision);
                    }
                    
                    str = str.substring(lbResults[0].length, str.length).trim();
                }
            }
            
            var ounces = null;
            var ozResults = str.match(/(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(oz|ounces)/i);
            if (ozResults) {
                ounces = 0;
                if (ozResults[2]) { // have a decimal match of form 100.7
                    ounces += ozResults[2]*1;
                } else if (ozResults[3]) {
                    ounces += that._processFracResults(ozResults[3], highPrecision);
                }
            }

            var kilos = null;
            if (pounds === null && ounces === null) { // Did not match either lbs or oz, now look for kg
                
                var kgResults = str.match(/^(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(kg|kgs|kilo|kilos|kilograms)$/i);
                if (kgResults) {
                    kilos = 0;

                    if (kgResults[2]) { // have a decimal match of form 100.7
                        kilos += kgResults[2]*1;
                    } else if (kgResults[3]) {
                        kilos += that._processFracResults(kgResults[3], highPrecision);
                    }

                    fractional_pounds = kilos * 2.20462262;
                    if (!highPrecision) { fractional_pounds = parseFloat(fractional_pounds.toFixed(3)); }
                }
            }
            else {
                // leave out the dollar sign from the regex above - see if kgs show up anywhere (instead of exclusively)
                if (str.match(/(([0-9]*\.?[0-9]+)|([0-9]* *[0-9]+\/[0-9]+))[ ]*(kg|kgs|kilo|kilos|kilograms)/i)) {
                    // user entered kilos AND pounds/ounces - that's crazy - we'll return null
                    fractional_pounds = null;
                }
                else {
                    // We matched either pounds or ounces or both, so normalize it
                    if (pounds === null) { pounds = 0; }
                    if (ounces === null) { ounces = 0; }

                    // Kilos, rounded to 2 decimal places.
                    fractional_pounds = pounds + (ounces * 0.0625);
                    kilos = Math.round(fractional_pounds / 2.20462262 * 100) / 100; 
                }
            }

            if (fractional_pounds === null) {
                // Input could not be parsed as a valid weight
                return {
                    valueLbs: null,
                    display: '',
                    displayMetric: ''
                };
            }

            // Set up display vars
            pounds = Math.floor(fractional_pounds);
            if (fractional_pounds <= 20) {   // Is 20 the right number?
                ounces = Math.round((fractional_pounds - pounds) / 0.0625);
            }
            else {
                ounces = 0;
            }
            // kilos, pounds, and ounces are all non-null and valid at this point
            
            var kilosDisplay = kilos + ' kg';
            
            var display = '';
            if (pounds) {
                display = pounds + ' lbs';
                if (ounces) {
                    display += ' ' + ounces + ' oz';
                }
            }
            else {
                display = ounces + ' oz';
            }
            
            return {
                valueLbs: fractional_pounds,
                display: display,
                displayMetric: kilosDisplay
            };
        },

        isNumber: function(n) {
            // stolen from a more recent version of jQuery than we use
            if (!n && n !== 0) { return false; }
            return !isNaN(parseFloat(n)) && isFinite(n);
        },

        intToWords: function(s) {
            /* Author's comments:
             *  // Convert numbers to words
             *  // copyright 25th July 2006, by Stephen Chapman http://javascript.about.com
             *  // permission to use this Javascript on your web page is granted
             *  // provided that all of the code (including this copyright notice) is
             *  // used exactly as shown (you can change the numbering system if you wish)
             *  // American Numbering System
             *
             * RS: I reformatted and made some modifications to this function. Hopefully by
             * "used exactly as shown," the author meant providing the right kind of input.
             * In any case, there's no explicit GPL or any other license.
             *
             * modifications:
             *  returning trimmed values like 'one' instead of 'one '
             *  handling zero and negative values as input
             *  handling hex string input
             *  adding curly braces to single line ifs / fors
             *  returning null on invalid input, rather than a string about the error
             *  getting rid of all the reliance on casting via "==" and "==="
             */
            var th = ['', 'thousand', 'million', 'billion', 'trillion'];

            var dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
            var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
            var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

            s = s.toString();
            s = s.replace(/[\, ]/g, '');
            if (!that.isNumber(s)) { return null; } // not a number
            var x = s.indexOf('.');
            if (x === -1) { x = s.length; }
            if (x > 15) { return null; } // too big
            if (s.indexOf('x') !== -1) { return null; } // we don't handle hex string input well (but hex literal input is fine)

            if (s === '0') { return dg[0]; }

            var n = s.split('');
            var str = '';
            var sk = 0;
            for (var i = 0; i < x; i++) {
                if (n[i] === '-') {
                    str += 'negative ';
                    continue;
                }
                if ((x - i) % 3 === 2) {
                    if (n[i] === '1') {
                        str += tn[Number(n[i + 1])] + ' ';
                        i++;
                        sk = 1;
                    } else if (n[i] !== '0') {
                        str += tw[n[i] - 2] + ' ';
                        sk = 1;
                    }
                } else if (n[i] !== '0') {
                    str += dg[n[i]] + ' ';
                    if ((x - i) % 3 === 0) { str += 'hundred '; }
                    sk = 1;
                }
                if ((x - i) % 3 === 1) {
                    if (sk) { str += th[(x - i - 1) / 3] + ' '; }
                    sk = 0;
                }
            }
            if (x !== s.length) {
                var y = s.length;
                str += 'point ';
                for (var i = x + 1; i < y; i++) { str += dg[n[i]] + ' '; }
            }
            return str.replace(/\s+/g, ' ').trim();
        },
        containsUrl: function(s) {
            return (/[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=-]{2,256}\.[a-z_-]{2,50}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/).test(s);
        },
        getWordObjArray: function (s) {
            if (s) {
                return s.split(' ').map(function(word) {
                    return {
                        word: word,
                        isLink: that.containsUrl(word)
                    };
                });
            }
            return [];
        }
    };

    return that;

})();
